<!--
  This component has an instance on
  Views.Responsive\LetterJacket\Shared\ProductDetails\LetterJacketSize.cshtml partial view
-->
<template>
  <div>
    <div class="letter-jacket-sizing-images">
      <div class="row hidden-xs hidden-sm hidden-md">
        <div class="col-lg-2">
          <letter-jacket-sample-images-nav
            :sample-images="sizingImages"
            :selected-image-index="selectedImageIndex"
            class="sample-images__top"
            @image-clicked="handleNavImageClick"
          />
        </div>
        <div class="col-lg-9">
          <img
            v-if="selectedSizingImage"
            :src="selectedSizingImage"
            :class="selectedImageClasses"
            @click="handleSizingImageClick"
          >
        </div>
      </div>
      <div class="row hidden-lg">
        <div class="col-xs-10 col-xs-offset-1">
          <img
            v-if="selectedSizingImage"
            :src="selectedSizingImage"
            class="responsive-img letter-jacket-sizing-images__selected-image"
            @click="handleSizingImageClick"
          >
        </div>
        <div class="col-xs-10 col-xs-offset-1">
          <letter-jacket-sample-images-nav
            :sample-images="sizingImages"
            :selected-image-index="selectedImageIndex"
            class="sample-images__bottom"
            @image-clicked="handleNavImageClick"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-10 col-xs-offset-1">
        <vue-markdown>{{ contentfulText('letter-jacket-sizing-product-detail-sizing-description').Content }}</vue-markdown>
      </div>
    </div>
    <jacket-sizing-video-modal
      v-if="showVideoModal"
      :video-title="contentfulText('letter-jacket-sizing-product-detail-video-title').Content"
      :video-url="contentfulText('letter-jacket-sizing-product-detail-video-url').Content"
      @modal-close="showVideoModal = false"
    />
  </div>
</template>

<script>
import LetterJacketSampleImagesNav from '../LetterJacketSampleImages/LetterJacketSampleImagesNav.vue'
import JacketSizingVideoModal from './JacketSizingVideoModal'

import VueMarkdown from 'vue-markdown'

export default {
  name: 'JacketSizing',
  components: {
    JacketSizingVideoModal,
    LetterJacketSampleImagesNav,
    VueMarkdown
  },
  data () {
    return {
      imageSlugs: [
        'letter-jacket-sizing-product-detail-video-thumbnail-image',
        'letter-jacket-sizing-product-detail-image-001',
        'letter-jacket-sizing-product-detail-image-002',
        'letter-jacket-sizing-product-detail-image-003'
      ],
      selectedImageIndex: 0,
      showVideoModal: false
    }
  },
  computed: {
    content () {
      return this.$store.state.letterJackets.letterJacketContent.sizingProductDetailModuleContent
    },
    sizingImages () {
      const result = []

      this.imageSlugs.forEach(is => {
        const image = this.contentfulImage(is)

        if (image !== null) {
          result.push(image.Image.File.Url)
        }
      })

      return result
    },
    selectedSizingImage () {
      let selectedImageSlug = this.imageSlugs[this.selectedImageIndex]

      const image = this.contentfulImage(selectedImageSlug)

      if (image !== null) {
        return image.Image.File.Url
      }

      return null
    },
    selectedImageClasses () {
      return {
        'responsive-img': true,
        'letter-jacket-sizing-images__selected-image--clickable': this.videoThumbnailImageIsSelected
      }
    },
    videoThumbnailImageIsSelected () {
      return this.imageSlugs[this.selectedImageIndex] === 'letter-jacket-sizing-product-detail-video-thumbnail-image'
    }
  },
  methods: {
    handleNavImageClick (imageIndex) {
      this.selectedImageIndex = imageIndex
    },
    handleSizingImageClick () {
      if (this.videoThumbnailImageIsSelected) {
        this.showVideoModal = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.letter-jacket-sizing-images {
  margin-bottom: 40px;

  &__selected-image {
    border: 1px solid #757575;

    &--clickable {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/JacketSizing/JacketSizing.vue